// games/rpg/map.js
export const MAP = [
  "######################################",
  "#....................................#",
  "#............_-a.....................#",
  "#......##....é&z.....................#",
  "#............è(e.....................#",
  "#............àçr.....................#",
  "#......+++++++++.....................#",
  "#....................................#",
  "#....................................#",
  "#....................................#",
  "#........................._-a........#",
  "#.........................é&z........#",
  "#.........................è(e........#",
  "#.........................àçr........#",
  "#....................................#",
  "#....................................#",
  "######################################",
];

export const TILE_SIZE = 32;
